import { View } from "@westpierstudio/luma/mvc";
import { GameServices } from "game/GameServices";

export class Background extends View {

    constructor(protected override readonly services: GameServices) {
        super(services);

        const {factory, layout, resources} = this.services;

        const spec = resources.getSpec(`background`);
        factory.applySpec(this, spec);

        for (const childName of Object.keys(spec.slices)) {
            factory.createSprite(spec.slices[childName], this);
        }

        this.resize();
        layout.onResize.add(() => this.resize());
    }

    private resize(): void {

        const bounds = this.services.layout.getScreenBoundaryInBucketSpace();

        if (bounds.width > bounds.height) {
            this.width = bounds.width;
            this.scale.y = this.scale.x;

        } else {
            this.height = bounds.height;
            this.scale.x = this.scale.y;
        }
    }
}